import * as PIXI from "pixi.js";
import { gameAssets, hideJackpotPanel, instances, showGrandJackpotWin, showJackpotPanel, showMajorJackpotWin, showMinorJackpotWin, toggleButtons } from "./gameUI";
import { playDisable, playMinus, playPlus } from "./soundManager";
import { tweenPulsate } from "./utility";
import { setLanguage } from "./gameService";
import { isAppleMobileDevice } from "./appPixi";
import { fruitData } from "./data";

export class FTUE {
    ftueContainer = null;
    ftueBoard = null;
    ftueEngContainer = null;
    ftueTagContainer = null;
    maskGraphic = null;
    tutorialNormal = [];
    tutorialSelected = []
    englishPages = []
    tagalogPages = [];
    pointer = 0
    ftueEngScroll = false;
    ftueTagScroll = false
    currentContainer = this.tagalogPages


    englishTutorialContainer = null;
    tagalogTutorialContainer = null;

    constructor() {
        this.ftueContainer = new PIXI.Container();
        this.ftueContainer.y = -20
        this.ftueContainer.visible = false;
        gameAssets.popupContainer.addChild(this.ftueContainer)
        this.setupPopBoard()
        this.setupMask();
        this.setupEnglishContent()
        this.setupTagalogContent()
        this.setupTutorialFooter();
        this.setupArrow()
        this.setupFtueEnd();
    }

    setupFtueEnd() {
        this.skip_en = new PIXI.Sprite(PIXI.Assets.get('skip_en'));
        this.skip_en.anchor.set(0.5);
        this.skip_en.interactive = true;
        this.skip_en.cursor = 'pointer'
        this.skip_en.visible = false;
        this.skip_en.position.set(260, -435)

        this.skip_ph = new PIXI.Sprite(PIXI.Assets.get('skip_ph'));
        this.skip_ph.anchor.set(0.5)
        this.skip_ph.scale.set(0.5)
        this.skip_ph.interactive = true;
        this.skip_ph.visible = false;
        this.skip_ph.cursor = 'pointer'
        this.skip_ph.position.set(260, -435)

        this.skip_en.on('pointerdown', (event) => {
            this.closeFtue()
        })

        this.skip_ph.on('pointerdown', (event) => {
            this.closeFtue()
        })

        this.ftueContainer.addChild(this.skip_en, this.skip_ph)
    }

    closeFtue() {
        toggleButtons(true)

        this.ftueContainer.visible = false;
        gameAssets.popupDimmer.visible = false;
        if (fruitData.isJackpotActive) {
            showJackpotPanel()
            showGrandJackpotWin(fruitData.grandCurrentJackpotValue)
            showMajorJackpotWin(fruitData.majorCurrentJackpotValue)
            showMinorJackpotWin(fruitData.minorCurrentJackpotValue)
        } else {
            hideJackpotPanel();
        }
    }

    setupArrow() {
        this.arrow = new PIXI.Sprite(PIXI.Assets.get('scroll_arrow'));
        this.arrow.anchor.set(0.5);
        this.arrow.position.set(0, 300);
        this.arrow.scale.set(1.1);
        this.arrow.interactive = true;
        this.arrow.visible = false;

        this.arrow.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.ftueLanguage == 'eng') {
                    if (fruitData.showAutoAndTurbo) this.ftueEngScroll = true;
                } else {
                    if (this.pointer == 10) {
                        if (fruitData.showAutoAndTurbo) this.ftueTagScroll = true;
                    } else {
                        this.ftueTagScroll = true;
                    }
                }
                this.arrow.visible = false;
            }
        });

        tweenPulsate(this.arrow, 0.3, 1.5)

        this.ftueContainer.addChild(this.arrow)
    }

    setupTagalogContent() {
        this.tagalogTutorialContainer = new PIXI.Container();
        this.tagalogTutorialContainer.y = -45
        this.tagalogTutorialContainer.mask = this.maskGraphic;
        this.tagalogTutorialContainer.visible = false;

        this.ftueContainer.addChild(this.tagalogTutorialContainer)

        this.tagPage1Container = new PIXI.Container();
        this.tagPage2Container = new PIXI.Container();
        this.tagPage3Container = new PIXI.Container();
        this.tagPage4Container = new PIXI.Container();
        this.tagPage5Container = new PIXI.Container();
        this.tagPage6Container = new PIXI.Container();
        this.tagPage7Container = new PIXI.Container();
        this.tagPage8Container = new PIXI.Container();
        this.tagPage9Container = new PIXI.Container();
        this.tagPage10Container = new PIXI.Container();
        this.tagPage11Container = new PIXI.Container();
        this.tagPage12Container = new PIXI.Container();

        for (let i = 1; i <= 12; i++) {
            this.tagalogPages.push(this[`tagPage${i}Container`]);
        }

        {
            const text1 = new PIXI.Text('Maghiwa ng Prutas', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P1'));
            img1.anchor.set(0.5);
            img1.scale.set(0.7)
            img1.position.set(0, -90)

            const text2 = new PIXI.Text('Mamili ng prutas para', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 39 : 42,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-105, 100);

            const text3 = new PIXI.Text('HIWAIN.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 39 : 42,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(220, 100);

            const text4 = new PIXI.Text('Ang bawat', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-240, 175);

            const text5 = new PIXI.Text('Prutas ay mayroong 50%', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(100, 175);

            const text6 = new PIXI.Text('pagkakataon', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(-190, 215);

            const text7 = new PIXI.Text('na matagumpay na', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(120, 215);

            const text8 = new PIXI.Text("mahiwa, ito'y magpapakita ng", {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(-70, 260);

            const text9 = new PIXI.Text("Barya", {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(270, 260);

            const text10 = new PIXI.Text("kung tama ang pili mo.", {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5)
            text10.position.set(0, 300);

            this.tagPage1Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10)
        }

        {
            const text1 = new PIXI.Text('Manalo ng mga Premyo', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 55,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P2'));
            img1.anchor.set(0.5);
            img1.scale.set(0.75)
            img1.position.set(0, -90);

            const text2 = new PIXI.Text('Ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-305, 105);

            const text3 = new PIXI.Text('PREMYO', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(-175, 105);

            const text4 = new PIXI.Text('ay ibinibigay ay batay', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(130, 105);

            const text5 = new PIXI.Text('sa', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(-195, 147);

            const text6 = new PIXI.Text('kabuuang bilang ng', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(30, 147);

            const text7 = new PIXI.Text('matagumpay na HIWA', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-130, 190);

            const text8 = new PIXI.Text('pagkatapos', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(215, 190);

            const text9 = new PIXI.Text('makumpleto ang lahat ng rounds.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(0, 235);

            this.tagPage2Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9)
        }

        {
            const text1 = new PIXI.Text('Pagtaas ng Premyo!', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 60,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -325);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_A'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -220);

            const text2 = new PIXI.Text('hanggang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 45,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(0, -135);

            const img2 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_B'));
            img2.anchor.set(0.5);
            img2.scale.set(0.8)
            img2.position.set(0, -25);

            const text3 = new PIXI.Text('Pagkatapos makumpleto ang lahat ng\n slices, ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text3.anchor.set(0.5)
            text3.position.set(0, 100);

            const text4 = new PIXI.Text('pinakamababang antas ng', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text4.anchor.set(0.5)
            text4.position.set(100, 120);

            const text5 = new PIXI.Text('PREMYO', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text5.anchor.set(0.5)
            text5.position.set(-275, 170);

            const text6 = new PIXI.Text('ay may pagkakataong', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text6.anchor.set(0.5)
            text6.position.set(5, 170);

            const text7 = new PIXI.Text('maging', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text7.anchor.set(0.5)
            text7.position.set(280, 170);

            const text8 = new PIXI.Text('pinakamataas na antas ng', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text8.anchor.set(0.5)
            text8.position.set(-90, 210);

            const text9 = new PIXI.Text('PREMYO', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text9.anchor.set(0.5)
            text9.position.set(235, 210);

            const text10 = new PIXI.Text('para sa mga napiling slices.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 34 : 37,
                fontWeight: "600",
                align: "left",
                lineHeight: 44.4
            });
            text10.anchor.set(0.5)
            text10.position.set(0, 250);

            //Pagkatapos makumpleto ang

            this.tagPage3Container.addChild(text1, img1, text2, img2, text3, text4, text5, text6, text7, text8, text9, text10)
        }

        {
            const text1 = new PIXI.Text('Paano Manalo?', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 60,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P4'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -135);

            const text2 = new PIXI.Text('Ang mga manlalaro ay', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-130, 65);

            const text3 = new PIXI.Text('kailanagang', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(220, 65);

            const text4 = new PIXI.Text('matagumpay na MAHIWA ang', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-70, 110);

            const text5 = new PIXI.Text('prutas,', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(280, 110);

            const text6 = new PIXI.Text('Mas maraming prutas ang matagumpay', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 33 : 36,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(0, 152);

            const text7 = new PIXI.Text('na NAHIWA mas mataas ang premyong', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 33 : 36,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(0, 195);

            const text8 = new PIXI.Text('matatanggap.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 35 : 38,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(0, 230);

            this.tagPage4Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8)
        }

        {
            const text1 = new PIXI.Text('Bar ng Pag-Usad', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 70,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -325);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P5'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(205, 95);

            const text2 = new PIXI.Text('Pwedeng Mapanalunan', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 33 : 35,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-155, -110);

            const text3 = new PIXI.Text('Bawat matagumpay na\npaghiwa ay nagtutulak\nsa manlalaro na\numusad pataas sa metro\nng premyo', {
                fill: "#00FF00",
                fontFamily: "notoSans",
                fontSize: 35,
                fontWeight: "600",
                align: "left",
                lineHeight: 42
            });
            text3.anchor.set(0.5)
            text3.position.set(-115, 230);

            const text4 = new PIXI.Text('Ang kasalukuyang\npremyo ay\nipinapakita sa ilalim\nng metro ng premyo', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 35,
                fontWeight: "600",
                align: "left",
                lineHeight: 42
            });
            text4.anchor.set(0.5)
            text4.position.set(-150, 465);

            const text5 = new PIXI.Text('Subaybayan ang iyong\nprogreso tungo sa\npanalong premyo. Mas\nmaraming matagumpay\nna paghiwa ay\nmagdadagdag sa\nposibleng premyo.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 35,
                fontWeight: "600",
                align: "left",
                lineHeight: 42
            });
            text5.anchor.set(0.5)
            text5.position.set(-120, 710);

            this.tagPage5Container.addChild(text1, img1, text2, text3, text4, text5)
        }

        {
            const text1 = new PIXI.Text('Ang Pulang Stopwatch', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 57,
                fontWeight: "900",
                align: "center",
                lineHeight: 68.4
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P6'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -110);

            const text2 = new PIXI.Text('Ipinapakita ng tagapagpahiwatig na', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
                lineHeight: 46.8
            });
            text2.anchor.set(0.5)
            text2.position.set(0, 100);

            const text3 = new PIXI.Text('ang kabuuang natitirang mga hiwa', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
                lineHeight: 46.8
            });
            text3.anchor.set(0.5)
            text3.position.set(0, 145);

            const text4 = new PIXI.Text('hanggang matapos ang laro.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
                lineHeight: 48
            });
            text4.anchor.set(0.5)
            text4.position.set(0, 190);

            this.tagPage6Container.addChild(text1, img1, text2, text3, text4)
        }

        {
            const text1 = new PIXI.Text('Ang Pabilog na Orasan', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 58,
                fontWeight: "900",
                align: "center",
                lineHeight: 69.6
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P7'));
            img1.anchor.set(0.5);
            img1.scale.set(0.7)
            img1.position.set(0, -75);

            const text2 = new PIXI.Text('Mayroon kang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 34,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-230, 145);

            const text3 = new PIXI.Text('10 segundo', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 31 : 34,
                fontWeight: "600",
                align: "center",
                lineHeight: 40.8
            });
            text3.anchor.set(0.5)
            text3.position.set(-5, 145);

            const text4 = new PIXI.Text('upang magawa', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 31 : 34,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(225, 145);

            const text5 = new PIXI.Text('mo ang hiwa! Hindi mo nagawa!, at ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(0, 185);

            const text6 = new PIXI.Text('laro ay, maghahati ng ibat-ibang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(0, 225);

            const text7 = new PIXI.Text('prutas para sa iyo!', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(0, 265);

            this.tagPage7Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7)

        }

        {
            const text1 = new PIXI.Text('Naku po! Natalo ako.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 60,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P8'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -95);

            const text2 = new PIXI.Text('Ang', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-305, 155);

            const text3 = new PIXI.Text('PAGHIWA', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(-165, 155);

            const text4 = new PIXI.Text('ng', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-40, 155);

            const text5 = new PIXI.Text('maling prutas', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(135, 155);

            const text6 = new PIXI.Text('ay', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(305, 155);

            const text7 = new PIXI.Text('magpapakita ng', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-175, 200);

            const text8 = new PIXI.Text('BOMBA', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(70, 200);

            const text9 = new PIXI.Text('na hindi', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(235, 200);

            const text10 = new PIXI.Text('ka pinauusad pataas sa Metro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5)
            text10.position.set(0, 245);

            const text11 = new PIXI.Text('ng', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text11.anchor.set(0.5)
            text11.position.set(-80, 285);

            const text12 = new PIXI.Text('Premyo.', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text12.anchor.set(0.5)
            text12.position.set(30, 290);


            this.tagPage8Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11, text12)
        }

        {
            const text1 = new PIXI.Text('Ang Puso, Ang Iyong Buhay', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 48,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P9'));
            img1.anchor.set(0.5);
            img1.position.set(0, -150);

            const text2 = new PIXI.Text('Mag-ingat!', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 33 : 36,
                fontWeight: "600",
                align: "center",
                lineHeight: 43.2
            });
            text2.anchor.set(0.5)
            text2.position.set(-245, 50);

            const text3 = new PIXI.Text('Piliin ang tamang prutas na', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 33 : 36,
                fontWeight: "600",
                align: "center",
                lineHeight: 43.2
            });
            text3.anchor.set(0.5)
            text3.position.set(105, 50);

            const text4 = new PIXI.Text('hihiwain-', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text4.anchor.set(0.5)
            text4.position.set(-255, 95);

            const text5 = new PIXI.Text('ang paghiwa sa maling prutas', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text5.anchor.set(0.5)
            text5.position.set(90, 95);

            const text6 = new PIXI.Text('ay maaring magsimula ng bomba.Kapag', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text6.anchor.set(0.5)
            text6.position.set(0, 140);

            const text7 = new PIXI.Text('tinamaan mo ang bomba, ay,', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text7.anchor.set(0.5)
            text7.position.set(-105, 185);

            const text8 = new PIXI.Text('mawawalan', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 32 : 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text8.anchor.set(0.5)
            text8.position.set(255, 185);

            const text9 = new PIXI.Text('ka ng 1 puso', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 31 : 34,
                fontWeight: "600",
                align: "center",
                lineHeight: 40.8
            });
            text9.anchor.set(0.5)
            text9.position.set(-248, 225);

            const text10 = new PIXI.Text('mula sa iyong puso ng buhay.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 31 : 34,
                fontWeight: "600",
                align: "center",
                lineHeight: 40.8
            });
            text10.anchor.set(0.5)
            text10.position.set(113, 225);

            const text11 = new PIXI.Text('Maubos mo ang lahat ng puso... at ito ang\nkatapusan ng laro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 33,
                fontWeight: "600",
                align: "center",
                lineHeight: 39.6
            });
            text11.anchor.set(0.5)
            text11.position.set(0, 287);

            this.tagPage9Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11)
        }

        {
            const text1 = new PIXI.Text('Awtomatikong Pagtatapos', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 47 : 50,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P12'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, 5);

            const text2 = new PIXI.Text('Ang laro ay awtomatikong magtatapos\nkapag nagamit mo na lahat ang\niyong hiniwa.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text2.anchor.set(0.5)
            text2.position.set(0, 120);

            const text3 = new PIXI.Text('Ang mga hiwa ay mababawasan ng 1 sa\nbawat matagumpay o nabigong\npaghiwa.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 35,
                fontWeight: "600",
                align: "center",
                lineHeight: 42
            });
            text3.anchor.set(0.5)
            text3.position.set(0, 260);

            this.tagPage10Container.addChild(text1, img1, text2, text3)
        }

        {
            const childrenToAdd = [];

            const text1 = new PIXI.Text('Gampanin ng Laro', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 60,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -330);
            childrenToAdd.push(text1);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_A'));
            img1.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img1.scale.set(0.8);
                img1.position.set(-265, -145);
            } else {
                img1.scale.set(0.4);
                img1.position.set(-255, -190);
            }
            childrenToAdd.push(img1);

            const text2 = new PIXI.Text('Pindutan sa paglaro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 40 : 30,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                text2.position.set(55, -140);
            } else {
                text2.position.set(32, -190);
            }
            childrenToAdd.push(text2);

            const img4 = new PIXI.Sprite(PIXI.Assets.get('menuNormal'));
            img4.anchor.set(0.5);
            img4.scale.set(fruitData.showAutoAndTurbo ? 0.8 : 0.6);
            img4.position.set(fruitData.showAutoAndTurbo ? -270 : -255, fruitData.showAutoAndTurbo ? 290 : -80);
            childrenToAdd.push(img4);

            const text5 = new PIXI.Text('Pagbukas ng settings\nng laro', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 40 : 30,
                fontWeight: "600",
                align: "left",
                lineHeight: 42
            });
            text5.anchor.set(0.5);
            text5.position.set(40, fruitData.showAutoAndTurbo ? 290 : -80);
            childrenToAdd.push(text5);

            const im5 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_b'));
            im5.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                im5.scale.set(0.8);
                im5.position.set(0, 495);
            } else {
                im5.position.set(-80, 60);
                im5.scale.set(0.6);
            }
            childrenToAdd.push(im5);


            const imText = new PIXI.Text('Baguhin ang pagtaya\nsa Bet/Slices', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 39,
                fontWeight: "600",
                align: "left",
                lineHeight: 46.8
            });
            imText.anchor.set(0.5);
            imText.position.set(190, 5);
            im5.addChild(imText);

            const im6 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_c'));
            im6.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                im6.scale.set(0.8);
                im6.position.set(-185, 790);
            } else {
                im6.scale.set(0.45);
                im6.position.set(-220, 240);
            }
            childrenToAdd.push(im6)

            const imgg6Text = new PIXI.Text('Madaling\nPagtaya!', {
                fill: "#60004C",
                fontFamily: "notoSans",
                fontSize: 44,
                fontWeight: "600",
                align: "left",
                lineHeight: 52.8
            });
            imgg6Text.anchor.set(0.5);
            imgg6Text.position.set(0, -90);
            im6.addChild(imgg6Text);

            const im6Text = new PIXI.Text('Baguhin ang pagtaya\nsa Bet/Slices sa\npamamagitan ng pagpindot\n sa gitna.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 30 : 25,
                fontWeight: "600",
                align: "left",
                lineHeight: 36
            });
            im6Text.anchor.set(0.5);
            im6Text.position.set(fruitData.showAutoAndTurbo ? 155 : 90, fruitData.showAutoAndTurbo ? 710 : 220);
            im6.addChild(im6Text);
            childrenToAdd.push(im6Text);

            if (fruitData.showAutoAndTurbo) {

                const img2 = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                img2.anchor.set(0.5);
                img2.scale.set(0.8);
                img2.position.set(-270, 25);

                const text3 = new PIXI.Text(
                    'Pagbukas o pagsasara ng\nawtomatikong paglaro autoplay',
                    {
                        fill: "#FFFFFF", fontFamily: "notoSans", fontSize: isAppleMobileDevice() ? 30 : 32,
                        fontWeight: "600", align: "left", lineHeight: 38.4
                    }
                );
                text3.anchor.set(0.5);
                text3.position.set(100, 20);

                const img3 = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                img3.anchor.set(0.5);
                img3.scale.set(0.8);
                img3.position.set(-270, 170);

                const text4 = new PIXI.Text('Pagbukas o pagsasara\nng turbo', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 35,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 42
                });
                text4.anchor.set(0.5);
                text4.position.set(45, 165);

                const text6 = new PIXI.Text('Awtomatikong Paglalaro', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 55,
                    fontWeight: "600",
                    align: "left",
                });
                text6.anchor.set(0.5)
                text6.position.set(0, 1030);

                const img6 = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                img6.anchor.set(0.5);
                img6.scale.set(0.85);
                img6.position.set(0, 1140);

                const text7 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 38 : 41,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 49.2
                });
                text7.anchor.set(0.5)
                text7.position.set(-300, 1250);

                const text8 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 38 : 41,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 49.2
                });
                text8.anchor.set(0.5)
                text8.position.set(-145, 1250);

                const text9 = new PIXI.Text('ay awtomatikong', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 38 : 41,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 49.2
                });
                text9.anchor.set(0.5)
                text9.position.set(140, 1250);

                const text10 = new PIXI.Text('sinisimulan ang bawat hiwa gamit \nang parehong sapalarang bilang\nsa lohikang pagbubuo gaya ng\nmanu-manong laro. Ang bawat\nkalalabasan ay natukoy nang\nhiwalay at sapalaran sa oras ng\npaghiwa.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text10.anchor.set(0.5)
                text10.position.set(0, 1440);

                const text11 = new PIXI.Text('Kapag ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text11.anchor.set(0.5)
                text11.position.set(-235, 1655);

                const text12 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text12.anchor.set(0.5)
                text12.position.set(-20, 1655);

                const text13 = new PIXI.Text('ay gumana,', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text13.anchor.set(0.5)
                text13.position.set(205, 1655);

                const text14 = new PIXI.Text('ang laro ay awtomatikong\nmagpapatuloy sa susunod na hiwa\nng walang kailangang ambag ng\nmanlalaro', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text14.anchor.set(0.5)
                text14.position.set(0, 1770);

                const text15 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text15.anchor.set(0.5)
                text15.position.set(-300, 1930);

                const text16 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text16.anchor.set(0.5)
                text16.position.set(-150, 1930);

                const text17 = new PIXI.Text('ay gumagamit ng', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text17.anchor.set(0.5)
                text17.position.set(135, 1930);

                const text18 = new PIXI.Text('kasalukuyang ayos ng pustahan', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text18.anchor.set(0.5)
                text18.position.set(-25, 1970);

                const text19 = new PIXI.Text('na aktibo nang ang AUTOPLAY ay\npinasimulan.Ang ganitong settings\nay nanatiling hindi nagbabago sa\npanahon ng pagpapatakbo ng\nAUTOPLAY maliban kung manu-\nmanong binago o pinahinto ng\nmanlalaro.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text19.anchor.set(0.5)
                text19.position.set(5, 2155);

                const text20 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text20.anchor.set(0.5)
                text20.position.set(-295, 2385);

                const text21 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 36 : 39,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 46.8
                });
                text21.anchor.set(0.5)
                text21.position.set(-150, 2385);

                const text22 = new PIXI.Text('ay magtatapos kung', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text22.anchor.set(0.5)
                text22.position.set(150, 2385);

                const text23 = new PIXI.Text('ang manlalaro ay manu-manong\nihihinto ang AUTOPLAY.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text23.anchor.set(0.5)
                text23.position.set(-15, 2450);

                const text24 = new PIXI.Text('Ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text24.anchor.set(0.5)
                text24.position.set(-295, 2565);

                const text25 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text25.anchor.set(0.5)
                text25.position.set(-140, 2565);

                const text26 = new PIXI.Text('ay kinakailangang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text26.anchor.set(0.5)
                text26.position.set(150, 2565);

                const text27 = new PIXI.Text('maihinto bago matapos ang huling\npaghiwa upang matagumpay na\nmapigilan ang automatikong pag-\numpisa ng susunod na paghiwa.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text27.anchor.set(0.5)
                text27.position.set(10, 2680);

                const text28 = new PIXI.Text('Mabilisang Mode', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 60,
                    fontWeight: "600",
                    align: "left",
                });
                text28.anchor.set(0.5)
                text28.position.set(0, 2890);

                const img7 = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                img7.anchor.set(0.5);
                img7.scale.set(0.8);
                img7.position.set(0, 3000);

                const text29 = new PIXI.Text('Ang pagpindot sa', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text29.anchor.set(0.5)
                text29.position.set(-175, 3145);

                const text30 = new PIXI.Text('Mabilisang Mode', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text30.anchor.set(0.5)
                text30.position.set(170, 3145);

                const text31 = new PIXI.Text('(TURBO Mode)', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text31.anchor.set(0.5)
                text31.position.set(-205, 3195);

                const text32 = new PIXI.Text('ay nagpapa andar', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text32.anchor.set(0.5)
                text32.position.set(125, 3195);

                const text33 = new PIXI.Text('sa autoplay mode at nagpapabilis\nng paglalaro,', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text33.anchor.set(0.5)
                text33.position.set(-20, 3262);

                const text34 = new PIXI.Text('Kapag naka enable ang', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 35 : 38,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 45.6
                });
                text34.anchor.set(0.5)
                text34.position.set(-125, 3345);

                const text35 = new PIXI.Text('TURBO MODE', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 36 : 39,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 46.8
                });
                text35.anchor.set(0.5)
                text35.position.set(227, 3350);

                const text36 = new PIXI.Text('ay mas bumibilis ang takbo ng laro\nkapag nalalaktawan ang ilang\nanimasyon sa panalo (Win animation)\nat tunog nito.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 35 : 38,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 45.6
                });
                text36.anchor.set(0.5)
                text36.position.set(5, 3455);
                childrenToAdd.push(
                    text2, img2, text3, img3, text4,
                    text6, img6, text7, text8, text9, text10,
                    text11, text12, text13, text14, text15,
                    text16, text17, text18, text19, text20,
                    text21, text22, text23, text24, text25,
                    text26, text27, text28, img7, text29,
                    text30, text31, text32, text33, text34,
                    text35, text36
                );
            }

            this.tagPage11Container.addChild(...childrenToAdd);
        }

        {
            const text1 = new PIXI.Text('Na Diskonekta o\nDi Natuloy na Laro', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "900",
                align: "center",
                lineHeight: 60
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -305);

            const text2 = new PIXI.Text('Kung ang manlalaro ay madiskonekta habang\nsiya ay naglalaro, ang laro susubukang ikonekta\nng sistema upang automatikong maka konek\nmuli. Kung sakali ang manlalaro ay di maka \nkonek sa loob ng resonableng takdang oras,ang \nkatayuan ng laro ay mananatili at sosolusyunan\nna ayon sa mga alituntunin ng Fair play at \npagbawi ng laro ayon sa protokol. Ang mga\napektadong manlalaro ay maaring abisuhan at\nmaaring maibalik o matumbasan ang kabayaran \ndepende sa sitwasyon.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 26 : 29,
                fontWeight: "600",
                align: "left",
                lineHeight: 34.8
            });
            text2.anchor.set(0.5)
            text2.position.set(0, -40);

            const text3 = new PIXI.Text('Maaring sumangguni sa mga tuntunin sa ng\naming', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 27 : 30,
                fontWeight: "600",
                align: "left",
                lineHeight: 36
            });
            text3.anchor.set(0.5)
            text3.position.set(-20, 210);

            const text4 = new PIXI.Text('Patakaran ng Fair Play at mga', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 27 : 30,
                fontWeight: "600",
                align: "left",
                lineHeight: 36
            });
            text4.anchor.set(0.5)
            text4.position.set(-25, 230);

            const text5 = new PIXI.Text('kondisyon', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 27 : 30,
                fontWeight: "600",
                align: "left",
                lineHeight: 36
            });
            text5.anchor.set(0.5)
            text5.position.set(275, 230);

            const text6 = new PIXI.Text('para sa karagdagan pang detalye.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 27 : 30,
                fontWeight: "600",
                align: "left",
                lineHeight: 36
            });
            text6.anchor.set(0.5)
            text6.position.set(-95, 263);

            this.tagPage12Container.addChild(text1, text2, text3, text4, text5, text6)
        }

        this.applyTagDrag();

        this.tagPage1Container.visible = true;
        this.tagPage2Container.visible = false;
        this.tagPage3Container.visible = false;
        this.tagPage4Container.visible = false;
        this.tagPage5Container.visible = false;
        this.tagPage6Container.visible = false;
        this.tagPage7Container.visible = false;
        this.tagPage8Container.visible = false;
        this.tagPage9Container.visible = false;
        this.tagPage10Container.visible = false;
        this.tagPage11Container.visible = false;
        this.tagPage12Container.visible = false;


        this.tagalogTutorialContainer.addChild(this.tagPage1Container, this.tagPage2Container, this.tagPage3Container, this.tagPage4Container, this.tagPage5Container, this.tagPage6Container, this.tagPage7Container, this.tagPage8Container, this.tagPage9Container, this.tagPage10Container, this.tagPage11Container, this.tagPage12Container)
    }

    applyTagDrag() {

        {
            this.tagPage11Container.interactive = fruitData.showAutoAndTurbo;
            this.tagPage11Container.cursor = fruitData.showAutoAndTurbo ? 'grab' : 'default';

            let dragging = false;
            let startY = 0;
            let containerStartY = 0;

            const MIN_Y = -3220;  // how far up the container can go
            const MAX_Y = 0;     // how far down (usually 0 = starting pos)

            this.tagPage11Container
                .on('pointerdown', (event) => {
                    if (!fruitData.showAutoAndTurbo) return;
                    dragging = true;
                    startY = event.data.global.y;
                    containerStartY = this.tagPage11Container.y;
                })
                .on('pointermove', (event) => {
                    if (!dragging || !fruitData.showAutoAndTurbo) return;

                    const currentY = event.data.global.y;
                    const delta = currentY - startY;

                    let newY = containerStartY + delta;

                    if (newY < MIN_Y) newY = MIN_Y;
                    if (newY > MAX_Y) newY = MAX_Y;

                    this.tagPage11Container.y = newY;

                    this.ftueTagScroll = false
                    this.arrow.visible = true;
                })
                .on('pointerup', () => {
                    dragging = false;
                })
                .on('pointerupoutside', () => {
                    dragging = false;
                });
        }

        {
            this.tagPage5Container.interactive = true;
            this.tagPage5Container.cursor = 'grab';

            let dragging = false;
            let startY = 0;
            let containerStartY = 0;

            const MIN_Y = -530;  // how far up the container can go
            const MAX_Y = 0;     // how far down (usually 0 = starting pos)

            this.tagPage5Container
                .on('pointerdown', (event) => {
                    dragging = true;
                    startY = event.data.global.y;
                    containerStartY = this.tagPage5Container.y;
                })
                .on('pointermove', (event) => {
                    if (!dragging) return;

                    const currentY = event.data.global.y;
                    const delta = currentY - startY;

                    let newY = containerStartY + delta;

                    if (newY < MIN_Y) newY = MIN_Y;
                    if (newY > MAX_Y) newY = MAX_Y;

                    this.tagPage5Container.y = newY;

                    this.ftueTagScroll = false
                    this.arrow.visible = true;

                })
                .on('pointerup', () => {
                    dragging = false;
                })
                .on('pointerupoutside', () => {
                    dragging = false;
                });
        }
    }

    setupTutorialFooter() {
        const rightNormal = new PIXI.Sprite(PIXI.Assets.get('right_b_normal'));
        rightNormal.anchor.set(0.5);
        rightNormal.interactive = true;
        rightNormal.cursor = 'pointer';
        rightNormal.scale.set(0.6);
        rightNormal.position.set(310, 340);

        rightNormal.on('pointerover', () => {
            rightNormal.texture = PIXI.Assets.get('right_b_selected')
        })

        rightNormal.on('pointerout', () => {
            rightNormal.texture = PIXI.Assets.get('right_b_normal')
        })

        rightNormal.on('pointerupoutside', () => {
            rightNormal.texture = PIXI.Assets.get('right_b_normal')
        })

        rightNormal.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.pointer < this.englishPages.length - 1) {
                    let current = this.currentContainer[this.pointer];
                    current.visible = false;
                    this.pointer++;
                    current = this.currentContainer[this.pointer];
                    current.visible = true;
                    this.updateTutorialIndicator()
                    playPlus(true);
                    this.ftueEngScroll = false;
                    this.ftueTagScroll = false;

                    if (
                        (this.ftueLanguage == 'eng' && this.pointer == 10 && fruitData.showAutoAndTurbo) ||
                        (this.ftueLanguage == 'tag' && (this.pointer == 4 || (this.pointer == 10 && fruitData.showAutoAndTurbo)))
                    ) {
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }
                } else {
                    playDisable(true);
                }
            }
        })


        for (let j = 0; j < this.englishPages.length; j++) {
            this.tutorialNormal[j] = new PIXI.Sprite(PIXI.Assets.get('tutorial_b_normal'));
            this.tutorialNormal[j].anchor.set(0.5);
            this.tutorialNormal[j].position.set(j == 0 ? -260 : this.tutorialNormal[j - 1].x + 47, 340);
            this.tutorialNormal[j].scale.set(0.5);

            this.tutorialSelected[j] = new PIXI.Sprite(PIXI.Assets.get('tutorial_b_selected'));
            this.tutorialSelected[j].anchor.set(0.5);
            this.tutorialSelected[j].position.set(0, 0);
            this.tutorialSelected[j].visible = false;

            this.tutorialNormal[j].addChild(this.tutorialSelected[j]);
        }

        this.updateTutorialIndicator()


        const leftNormal = new PIXI.Sprite(PIXI.Assets.get('left_b_normal'));
        leftNormal.anchor.set(0.5);
        leftNormal.position.set(-310, 340);
        leftNormal.scale.set(0.6);
        leftNormal.interactive = true;
        leftNormal.cursor = 'pointer';
        leftNormal.on('pointerover', () => { leftNormal.texture = PIXI.Assets.get('left_b_selected'); });
        leftNormal.on('pointerout', () => { leftNormal.texture = PIXI.Assets.get('left_b_normal'); });

        this.footerContainer = new PIXI.Container();
        this.footerContainer.visible = false;

        this.footerContainer.addChild(leftNormal, ...this.tutorialNormal, rightNormal);
        this.ftueContainer.addChild(this.footerContainer)

        leftNormal.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                if (this.pointer > 0) {
                    let current = this.currentContainer[this.pointer];
                    current.visible = false;
                    this.pointer--;
                    current = this.currentContainer[this.pointer];
                    current.visible = true;
                    this.updateTutorialIndicator()
                    playMinus(true);
                    this.ftueEngScroll = false;
                    this.ftueTagScroll = false;

                    if (
                        (this.ftueLanguage == 'eng' && this.pointer == 10 && fruitData.showAutoAndTurbo) ||
                        (this.ftueLanguage == 'tag' && (this.pointer == 4 || (this.pointer == 10 && fruitData.showAutoAndTurbo)))
                    ) {
                        this.arrow.visible = true;
                    } else {
                        this.arrow.visible = false;
                    }
                } else {
                    playDisable(true);
                }
            }
        });
    }

    scroll(delta) {
        if (this.ftueLanguage == 'eng') {
            if (this.pointer == 10 && fruitData.showAutoAndTurbo) {
                this.engPage11Container.y -= 1.5 * delta;
                if (this.engPage11Container.y < -2735) this.ftueEngScroll = false;
            } else {
                this.ftueEngScroll = false;
                this.engPage11Container.y = 0;
            }
        } else {
            if (this.pointer == 10) {
                if (fruitData.showAutoAndTurbo) {
                    this.tagPage11Container.y = this.tagPage11Container.y - 1.5 * delta;
                    if (this.tagPage11Container.y < -3280) {
                        this.ftueTagScroll = false;
                    }
                } else {
                    this.ftueTagScroll = false;
                    this.tagPage11Container.y = 0;
                }
            } else {
                this.tagPage5Container.y = this.tagPage5Container.y - 1.5 * delta;
                if (this.tagPage5Container.y < -530) {
                    this.ftueTagScroll = false;
                }
            }
        }
    }

    updateTutorialIndicator() {
        for (let j = 0; j < this.englishPages.length; j++) {
            this.tutorialSelected[j].visible = this.pointer === j;
        }
    }

    setupEnglishContent() {
        this.englishTutorialContainer = new PIXI.Container();
        this.englishTutorialContainer.y = -45
        this.englishTutorialContainer.mask = this.maskGraphic;
        this.ftueContainer.addChild(this.englishTutorialContainer)
        const data = PIXI.Assets.get('textEng');
        this.englishTutorialContainer.visible = false;

        this.engPage1Container = new PIXI.Container();
        this.engPage2Container = new PIXI.Container();
        this.engPage3Container = new PIXI.Container();
        this.engPage4Container = new PIXI.Container();
        this.engPage5Container = new PIXI.Container();
        this.engPage6Container = new PIXI.Container();
        this.engPage7Container = new PIXI.Container();
        this.engPage8Container = new PIXI.Container();
        this.engPage9Container = new PIXI.Container();
        this.engPage10Container = new PIXI.Container();
        this.engPage11Container = new PIXI.Container();
        this.engPage12Container = new PIXI.Container();

        for (let i = 1; i <= 12; i++) {
            this.englishPages.push(this[`engPage${i}Container`]);
        }

        const style1 = new PIXI.TextStyle({
            fill: "#FFFFFF",
            fontFamily: "notoSans",
            fontSize: 55,
            fontWeight: "500",
            align: "center",
        });

        const style2 = new PIXI.TextStyle({
            fill: "#FFF000",
            fontFamily: "notoSans",
            fontSize: 55,
            fontWeight: "700",
            align: "center",
        });

        {
            const text1 = new PIXI.Text(data.page1.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P1'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -80)

            const text2 = new PIXI.Text(data.page1.body.p1, style1);
            text2.anchor.set(0.5)
            text2.position.set(-85, 125)

            const text3 = new PIXI.Text(data.page1.body.p2, style2);
            text3.anchor.set(0.5)
            text3.position.set(205, 125);

            const text4 = new PIXI.Text(data.page1.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 48,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(-275, 195);

            const text5 = new PIXI.Text(data.page1.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "800",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(65, 195);

            const text6a = new PIXI.Text(data.page1.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "center",
            });
            text6a.anchor.set(0.5)
            text6a.position.set(-280, 245);

            const text6b = new PIXI.Text(data.page1.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "center",
            });
            text6b.anchor.set(0.5)
            text6b.position.set(45, 245);

            const text6c = new PIXI.Text(data.page1.description.p3c, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "600",
                align: "center",
            });
            text6c.anchor.set(0.5)
            text6c.position.set(-90, 295);

            const text7 = new PIXI.Text(data.page1.description.p4, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 45 : 48,
                fontWeight: "800",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(110, 295);
            this.engPage1Container.addChild(text1, img1, text2, text3, text4, text5, text6a, text6b, text6c, text7);
        }

        {
            const text1 = new PIXI.Text(data.page2.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P2'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(5, -95);

            const text2 = new PIXI.Text(data.page2.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5)
            text2.position.set(-300, 105)

            const text3 = new PIXI.Text(data.page2.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "800",
                align: "center",
            });
            text3.anchor.set(0.5)
            text3.position.set(-180, 105)

            const text4 = new PIXI.Text(data.page2.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5)
            text4.position.set(120, 105)

            const text5 = new PIXI.Text(data.page2.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5)
            text5.position.set(-300, 155)

            const text6 = new PIXI.Text(data.page2.description.p4a, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "800",
                align: "center",
            });
            text6.anchor.set(0.5)
            text6.position.set(45, 155)

            const text7 = new PIXI.Text(data.page2.description.p4b, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "800",
                align: "center",
            });
            text7.anchor.set(0.5)
            text7.position.set(-210, 205)

            const text8 = new PIXI.Text(data.page2.description.p5a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5)
            text8.position.set(85, 205)

            const text9 = new PIXI.Text(data.page2.description.p5b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5)
            text9.position.set(0, 255)

            this.engPage2Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9)
        }

        {
            const text1 = new PIXI.Text(data.page3.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_A'));
            img1.anchor.set(0.5);
            img1.scale.set(0.7)
            img1.position.set(0, -195);

            const text2 = new PIXI.Text(data.page3.body, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "center",
            })
            text2.anchor.set(0.5);
            text2.position.set(0, -120);

            const img2 = new PIXI.Sprite(PIXI.Assets.get('EN_P3_B'));
            img2.anchor.set(0.5);
            img2.scale.set(0.7)
            img2.position.set(0, -25);

            const text3 = new PIXI.Text(data.page3.description.p1a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text3.anchor.set(0.5);
            text3.position.set(0, 55);

            const text4 = new PIXI.Text(data.page3.description.p1b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text4.anchor.set(0.5);
            text4.position.set(-300, 105);

            const text5 = new PIXI.Text(data.page3.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text5.anchor.set(0.5);
            text5.position.set(-55, 105);

            const text6 = new PIXI.Text(data.page3.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text6.anchor.set(0.5);
            text6.position.set(230, 105);

            const text7 = new PIXI.Text(data.page3.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text7.anchor.set(0.5);
            text7.position.set(-105, 155);

            const text8 = new PIXI.Text(data.page3.description.p4a, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text8.anchor.set(0.5);
            text8.position.set(240, 155);

            const text9 = new PIXI.Text(data.page3.description.p4b, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text9.anchor.set(0.5);
            text9.position.set(-175, 205);

            const text10 = new PIXI.Text(data.page3.description.p5a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text10.anchor.set(0.5);
            text10.position.set(110, 205);

            const text11 = new PIXI.Text(data.page3.description.p5b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 42 : 45,
                fontWeight: "600",
                align: "center",
            })
            text11.anchor.set(0.5);
            text11.position.set(0, 250);

            this.engPage3Container.addChild(text1, img1, text2, img2, text3, text4, text5, text6, text7, text8, text9, text10, text11)
        }

        {
            const text1 = new PIXI.Text(data.page4.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P4'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -120);

            const text2 = new PIXI.Text(data.page4.body.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
            })
            text2.anchor.set(0.5);
            text2.position.set(-225, 70);

            const text3 = new PIXI.Text(data.page4.body.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 36 : 39,
                fontWeight: "600",
                align: "center",
            })
            text3.anchor.set(0.5);
            text3.position.set(125, 70);

            const text4 = new PIXI.Text(data.page4.body.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text4.anchor.set(0.5);
            text4.position.set(345, 70);

            const text5 = new PIXI.Text(data.page4.body.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text5.anchor.set(0.5);
            text5.position.set(-245, 115);

            const text6 = new PIXI.Text(data.page4.body.p4, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text6.anchor.set(0.5);
            text6.position.set(-85, 115);

            const text7 = new PIXI.Text(data.page4.body.p5a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text7.anchor.set(0.5);
            text7.position.set(165, 115);

            const text8 = new PIXI.Text(data.page4.body.p5b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text8.anchor.set(0.5);
            text8.position.set(-80, 160);

            const text9 = new PIXI.Text(data.page4.body.p5c, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text9.anchor.set(0.5);
            text9.position.set(45, 160);

            const text10 = new PIXI.Text(data.page4.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text10.anchor.set(0.5);
            text10.position.set(-300, 230);

            const text11 = new PIXI.Text(data.page4.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text11.anchor.set(0.5);
            text11.position.set(40, 230);

            const text12 = new PIXI.Text(data.page4.description.p3, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text12.anchor.set(0.5);
            text12.position.set(-250, 275);

            const text13 = new PIXI.Text(data.page4.description.p4, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text13.anchor.set(0.5);
            text13.position.set(-45, 275);

            const text14 = new PIXI.Text(data.page4.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            })
            text14.anchor.set(0.5);
            text14.position.set(215, 275);

            this.engPage4Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11, text12, text13, text14)
        }

        {
            const text1 = new PIXI.Text(data.page5.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P5'));
            img1.anchor.set(0.5);
            img1.scale.set(0.6)
            img1.position.set(220, 0);

            const text2 = new PIXI.Text(data.page5.sub_header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "center",
            })
            text2.anchor.set(0.5);
            text2.position.set(-140, -155);

            const text6 = new PIXI.Text('Each successful slice\nprogresses the player\nfurther up the prize\nmeter.', {
                fill: "#00FF00",
                fontFamily: "notoSans",
                fontSize: 27,
                fontWeight: "600",
                align: "left",
                lineHeight: 32.4
            })
            text6.anchor.set(0.5);
            text6.position.set(-170, -20);

            const text7 = new PIXI.Text('Your Current \nPrize is shown at\nthe base of the\nprize meter', {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 27,
                fontWeight: "600",
                align: "left",
                lineHeight: 32.4
            })
            text7.anchor.set(0.5);
            text7.position.set(-205, 125);

            const text8 = new PIXI.Text('Track your progress toward\nwinning prizes.\nMore successful slices\nincrease your potential prize.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 25,
                fontWeight: "600",
                align: "left",
                lineHeight: 30
            })
            text8.anchor.set(0.5);
            text8.position.set(-135, 265);

            this.engPage5Container.addChild(text1, img1, text2, text6, text7, text8)
        }

        {
            const text1 = new PIXI.Text(data.page6.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P6'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -95);

            const text2 = new PIXI.Text(data.page6.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 48,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, 115);

            const text3 = new PIXI.Text(data.page6.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 48,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(0, 165);

            this.engPage6Container.addChild(text1, img1, text2, text3)
        }

        {
            const text1 = new PIXI.Text(data.page7.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P7'));
            img1.anchor.set(0.5);
            img1.scale.set(0.7)
            img1.position.set(0, -60);

            const text2 = new PIXI.Text(data.page7.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(-235, 170);

            const text3 = new PIXI.Text(data.page7.description.p2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(0, 170);

            const text4 = new PIXI.Text(data.page7.description.p3a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(235, 170);

            const text5 = new PIXI.Text(data.page7.description.p3b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(0, 220);

            const text6 = new PIXI.Text(data.page7.description.p3c, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(0, 265);

            this.engPage7Container.addChild(text1, img1, text2, text3, text4, text5, text6)
        }

        {
            const text1 = new PIXI.Text(data.page8.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P8'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, -80);

            const text2 = new PIXI.Text(data.page8.description.p1, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(-260, 140);

            const text3 = new PIXI.Text(data.page8.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(-145, 140);

            const text4 = new PIXI.Text(data.page8.description.p3, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(25, 140);

            const text5 = new PIXI.Text(data.page8.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(255, 140);

            const text6 = new PIXI.Text(data.page8.description.p5, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(-245, 185);

            const text7 = new PIXI.Text(data.page8.description.p6a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5);
            text7.position.set(70, 185);

            const text8 = new PIXI.Text(data.page8.description.p6b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5);
            text8.position.set(-125, 230);

            const text9 = new PIXI.Text(data.page8.description.p7, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5);
            text9.position.set(45, 230);

            const text10 = new PIXI.Text(data.page8.description.p8, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 37 : 40,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5);
            text10.position.set(170, 230);

            this.engPage8Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10)

        }

        {
            const text1 = new PIXI.Text(data.page9.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 58 : 60,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P9'));
            img1.anchor.set(0.5);
            img1.scale.set(0.85)
            img1.position.set(0, -150);

            const text2 = new PIXI.Text(data.page9.description.p1, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(-240, 10);

            const text3 = new PIXI.Text(data.page9.description.p2a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(115, 10);

            const text4 = new PIXI.Text(data.page9.description.p2b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(-215, 55);

            const text5 = new PIXI.Text(data.page9.description.p3, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(100, 55);

            const text6 = new PIXI.Text(data.page9.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(0, 100);

            const text7 = new PIXI.Text(data.page9.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text7.anchor.set(0.5);
            text7.position.set(-115, 155);

            const text8 = new PIXI.Text(' ' + data.page9.description.p6, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text8.anchor.set(0.5);
            text8.position.set(235, 155);

            const text9 = new PIXI.Text(data.page9.description.p7, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text9.anchor.set(0.5);
            text9.position.set(0, 200);

            const text10 = new PIXI.Text(data.page9.description.p8a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text10.anchor.set(0.5);
            text10.position.set(0, 240);

            const text11 = new PIXI.Text(data.page9.description.p8b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 38 : 41,
                fontWeight: "600",
                align: "center",
            });
            text11.anchor.set(0.5);
            text11.position.set(0, 280);

            this.engPage9Container.addChild(text1, img1, text2, text3, text4, text5, text6, text7, text8, text9, text10, text11)
        }

        {
            const text1 = new PIXI.Text(data.page10.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -300);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P12'));
            img1.anchor.set(0.5);
            img1.scale.set(0.8)
            img1.position.set(0, 20);

            const text2 = new PIXI.Text(data.page10.description.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, 105);

            const text3 = new PIXI.Text(data.page10.description.p2, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text3.anchor.set(0.5);
            text3.position.set(0, 150);

            const text4 = new PIXI.Text(data.page10.description.p3, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text4.anchor.set(0.5);
            text4.position.set(0, 195);

            const text5 = new PIXI.Text(data.page10.description.p4, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text5.anchor.set(0.5);
            text5.position.set(0, 240);

            const text6 = new PIXI.Text(data.page10.description.p5, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 41 : 44,
                fontWeight: "600",
                align: "center",
            });
            text6.anchor.set(0.5);
            text6.position.set(0, 285);

            this.engPage10Container.addChild(text1, img1, text2, text3, text4, text5, text6)
        }

        {
            const childrenToAdd = [];

            const text1 = new PIXI.Text(data.page11.header, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 65,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -320);
            childrenToAdd.push(text1);

            const img1 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_A'));
            img1.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img1.scale.set(0.8)
                img1.position.set(-245, -160);
            } else {
                img1.scale.set(0.38);
                img1.position.set(-230, -190);
            }
            childrenToAdd.push(img1);

            const text2 = new PIXI.Text(data.page11.description1.p1, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 45 : 35,
                fontWeight: "600",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, fruitData.showAutoAndTurbo ? -155 : -190);
            childrenToAdd.push(text2);

            if (fruitData.showAutoAndTurbo) {
                const img2 = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                img2.anchor.set(0.5);
                img2.scale.set(0.8)
                img2.position.set(-245, 10);
                childrenToAdd.push(img2);

                const text3 = new PIXI.Text(data.page11.description1.p2a, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 37,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 44.4
                });
                text3.anchor.set(0.5);
                text3.position.set(20, -15);
                childrenToAdd.push(text3);

                const text4 = new PIXI.Text(data.page11.description1.p2b, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 37,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 44.4
                });
                text4.anchor.set(0.5);
                text4.position.set(-65, 25);
                childrenToAdd.push(text4);

                const img3 = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                img3.anchor.set(0.5);
                img3.scale.set(0.8)
                img3.position.set(-245, 150);
                childrenToAdd.push(img3);

                const text5 = new PIXI.Text(data.page11.description1.p3, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 37,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 44.4
                });
                text5.anchor.set(0.5);
                text5.position.set(-12, 130);
                childrenToAdd.push(text5);

                const text6 = new PIXI.Text(data.page11.description1.p2b, {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: 37,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 44.4
                });
                text6.anchor.set(0.5);
                text6.position.set(-70, 170);
                childrenToAdd.push(text6);
            }

            const img4 = new PIXI.Sprite(PIXI.Assets.get('menuNormal'));
            img4.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img4.scale.set(0.8)
                img4.position.set(-245, 275);
            } else {
                img4.scale.set(0.6)
                img4.position.set(-230, -100);
            }
            childrenToAdd.push(img4);

            const text7 = new PIXI.Text(data.page11.description1.p4a, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 37 : 30,
                fontWeight: "600",
                align: "center",
                lineHeight: 44.4
            });
            text7.anchor.set(0.5);
            text7.position.set(fruitData.showAutoAndTurbo ? 62 : 58, fruitData.showAutoAndTurbo ? 260 : -120);
            childrenToAdd.push(text7);

            const text8 = new PIXI.Text(data.page11.description1.p4b, {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 37 : 30,
                fontWeight: "600",
                align: "center",
                lineHeight: 44.4
            });
            text8.anchor.set(0.5);
            text8.position.set(fruitData.showAutoAndTurbo ? -20 : -10, fruitData.showAutoAndTurbo ? 295 : -80);
            childrenToAdd.push(text8);

            const img5 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_b'));
            img5.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img5.scale.set(0.7)
                img5.position.set(0, 450);
            } else {
                img5.scale.set(0.6)
                img5.position.set(-60, 30);
            }
            childrenToAdd.push(img5);

            const imgText1 = new PIXI.Text(' Change\n Bet/Slices', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "600",
                align: "left",
                lineHeight: 60
            });
            imgText1.anchor.set(0.5);
            imgText1.position.set(140, 0);
            img5.addChild(imgText1)

            const img6 = new PIXI.Sprite(PIXI.Assets.get('EN_P11_c'));
            img6.anchor.set(0.5);
            if (fruitData.showAutoAndTurbo) {
                img6.scale.set(0.7)
                img6.position.set(-165, 715);
            } else {
                img6.scale.set(0.5)
                img6.position.set(-200, 220);
            }
            childrenToAdd.push(img6);

            const imgText2 = new PIXI.Text('  Easy\nAccess\nOption', {
                fill: "#60004C",
                fontFamily: "notoSans",
                fontSize: 44,
                fontWeight: "600",
                align: "left",
                lineHeight: 52.8
            });
            imgText2.anchor.set(0.5);
            imgText2.position.set(0, -100);
            img6.addChild(imgText2)

            const text11 = new PIXI.Text(' Change\n Bet/Slices by\n tapping the\n center.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: fruitData.showAutoAndTurbo ? 35 : 30,
                fontWeight: "600",
                align: "left",
                lineHeight: 42
            });
            text11.anchor.set(0.5);
            text11.position.set(fruitData.showAutoAndTurbo ? 130 : 40, fruitData.showAutoAndTurbo ? 675 : 200);
            childrenToAdd.push(text11);

            if (fruitData.showAutoAndTurbo) {
                const text12 = new PIXI.Text('Autoplay', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 65,
                    fontWeight: "900",
                    align: "center",
                });
                text12.anchor.set(0.5);
                text12.position.set(0, 920);
                childrenToAdd.push(text12);

                const autoImg = new PIXI.Sprite(PIXI.Assets.get('auto_b_normal'));
                autoImg.anchor.set(0.5);
                autoImg.scale.set(0.8)
                autoImg.position.set(0, 1030)
                childrenToAdd.push(autoImg)

                const text13 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text13.anchor.set(0.5);
                text13.position.set(-225, 1150);
                childrenToAdd.push(text13);

                const text14 = new PIXI.Text('automatically initiates', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "center",
                    lineHeight: 48
                });
                text14.anchor.set(0.5);
                text14.position.set(105, 1150);
                childrenToAdd.push(text14);

                const text15 = new PIXI.Text('each slice using the same random\nnumber generation logic as\nmanual play. Each outcome is\ndetermined independently and\nrandomly at the time of the slice.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text15.anchor.set(0.5);
                text15.position.set(0, 1285);
                childrenToAdd.push(text15);

                const text16 = new PIXI.Text('When', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text16.anchor.set(0.5);
                text16.position.set(-270, 1490);
                childrenToAdd.push(text16);

                const text17 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text17.anchor.set(0.5);
                text17.position.set(-95, 1490);
                childrenToAdd.push(text17);

                const text18 = new PIXI.Text('is enabled, the', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text18.anchor.set(0.5);
                text18.position.set(160, 1490);
                childrenToAdd.push(text18);

                const text19 = new PIXI.Text('game will automatically continue\nto the next slice without requiring\nplayer input.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                })
                text19.anchor.set(0.5);
                text19.position.set(5, 1575);
                childrenToAdd.push(text19);

                const text20 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text20.anchor.set(0.5);
                text20.position.set(-225, 1730);
                childrenToAdd.push(text20);

                const text21 = new PIXI.Text('uses the', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text21.anchor.set(0.5);
                text21.position.set(-25, 1730);
                childrenToAdd.push(text21);

                const text22 = new PIXI.Text('current bet', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text22.anchor.set(0.5);
                text22.position.set(180, 1730);
                childrenToAdd.push(text22);

                const text23 = new PIXI.Text('configuration', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text23.anchor.set(0.5);
                text23.position.set(-195, 1770);
                childrenToAdd.push(text23);

                const text24 = new PIXI.Text('that was active', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text24.anchor.set(0.5);
                text24.position.set(95, 1770);
                childrenToAdd.push(text24);

                const text25 = new PIXI.Text('when AUTOPLAY was initiated.\nThese settings remain constant\nfor the duration of the AUTOPLAY\nsession unless manually changed\nby the player or interrupted.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text25.anchor.set(0.5);
                text25.position.set(0, 1910);
                childrenToAdd.push(text25);

                const text26 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text26.anchor.set(0.5);
                text26.position.set(-220, 2100);
                childrenToAdd.push(text26);

                const text27 = new PIXI.Text('end when the player', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text27.anchor.set(0.5);
                text27.position.set(90, 2100);
                childrenToAdd.push(text27);

                const text28 = new PIXI.Text('manually stops AUTOPLAY.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text28.anchor.set(0.5);
                text28.position.set(-65, 2137);
                childrenToAdd.push(text28);

                const text29 = new PIXI.Text('AUTOPLAY', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text29.anchor.set(0.5);
                text29.position.set(-220, 2245);
                childrenToAdd.push(text29);

                const text30 = new PIXI.Text('must be disabled before', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 35 : 38,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 45.6
                });
                text30.anchor.set(0.5);
                text30.position.set(115, 2245);
                childrenToAdd.push(text30);

                const text31 = new PIXI.Text('the final slice has ended to\nsuccessfully stop the next game\nfrom automatically starting.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text31.anchor.set(0.5);
                text31.position.set(-10, 2335);
                childrenToAdd.push(text31);

                const text32 = new PIXI.Text('Turbo Mode', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: 65,
                    fontWeight: "900",
                    align: "center",
                });
                text32.anchor.set(0.5);
                text32.position.set(0, 2500);
                childrenToAdd.push(text32);

                const turboImg = new PIXI.Sprite(PIXI.Assets.get('speed_b_normal'));
                turboImg.anchor.set(0.5);
                turboImg.scale.set(0.8)
                turboImg.position.set(0, 2610);
                childrenToAdd.push(turboImg);

                const text33 = new PIXI.Text('Pressing the', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text33.anchor.set(0.5);
                text33.position.set(-205, 2720);
                childrenToAdd.push(text33);

                const text34 = new PIXI.Text('TURBO', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text34.anchor.set(0.5);
                text34.position.set(-5, 2720);
                childrenToAdd.push(text34);

                const text35 = new PIXI.Text('button', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text35.anchor.set(0.5);
                text35.position.set(140, 2720);
                childrenToAdd.push(text35);

                const text36 = new PIXI.Text('activates the autoplay mode and\nspeeds up the game.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text36.anchor.set(0.5);
                text36.position.set(-5, 2787);
                childrenToAdd.push(text36);

                const text37 = new PIXI.Text('When', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text37.anchor.set(0.5);
                text37.position.set(-265, 2905);
                childrenToAdd.push(text37);

                const text38 = new PIXI.Text('TURBO MODE', {
                    fill: "#FFF000",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text38.anchor.set(0.5);
                text38.position.set(-65, 2905);
                childrenToAdd.push(text38);

                const text39 = new PIXI.Text('is enabled', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text39.anchor.set(0.5);
                text39.position.set(180, 2905);
                childrenToAdd.push(text39);

                const text40 = new PIXI.Text('some win animations and sounds\nare skipped, and the game moves\nfaster.', {
                    fill: "#FFFFFF",
                    fontFamily: "notoSans",
                    fontSize: isAppleMobileDevice() ? 37 : 40,
                    fontWeight: "600",
                    align: "left",
                    lineHeight: 48
                });
                text40.anchor.set(0.5);
                text40.position.set(5, 2996);
                childrenToAdd.push(text40);
            }
            console.log(fruitData.showAutoAndTurbo);

            this.engPage11Container.addChild(...childrenToAdd);

        }

        {
            const text1 = new PIXI.Text(data.page12.header1, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "900",
                align: "center",
            });
            text1.anchor.set(0.5);
            text1.position.set(0, -330);

            const text2 = new PIXI.Text(data.page12.header2, {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: 50,
                fontWeight: "900",
                align: "center",
            });
            text2.anchor.set(0.5);
            text2.position.set(0, -275);

            const text3 = new PIXI.Text('If a player is disconnected during\ngameplay, the game system will\nattempt to reconnect them\nautomatically. In case the player\ncannot reconnect within a reasonable\ntimeframe, the game state will be\npreserved and resolved as per the\nplatform’s fair play and recovery\nprotocols. Affected players may be\nnotified and refunded or compensated\nbased on the situation.', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 32,
                fontWeight: "900",
                align: "left",
                lineHeight: 38.4
            });
            text3.anchor.set(0.5);
            text3.position.set(0, -25);

            const text4 = new PIXI.Text('Please refer to our', {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 32,
                fontWeight: "900",
                align: "left",
                lineHeight: 38.4
            });
            text4.anchor.set(0.5);
            text4.position.set(-167, 225);

            const text5 = new PIXI.Text("Fair Play Policy's", {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 32,
                fontWeight: "900",
                align: "left",
                lineHeight: 38.4
            });
            text5.anchor.set(0.5);
            text5.position.set(130, 225);

            const text6 = new PIXI.Text("Terms and Conditions", {
                fill: "#FFF000",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 32,
                fontWeight: "900",
                align: "left",
                lineHeight: 38.4
            });
            text6.anchor.set(0.5);
            text6.position.set(-140, 265)

            const text7 = new PIXI.Text("for further", {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 32,
                fontWeight: "900",
                align: "left",
                lineHeight: 38.4
            });
            text7.anchor.set(0.5);
            text7.position.set(135, 265)

            const text8 = new PIXI.Text("details.", {
                fill: "#FFFFFF",
                fontFamily: "notoSans",
                fontSize: isAppleMobileDevice() ? 30 : 32,
                fontWeight: "900",
                align: "left",
                lineHeight: 38.4
            });
            text8.anchor.set(0.5);
            text8.position.set(-260, 305)

            this.engPage12Container.addChild(text1, text2, text3, text4, text5, text6, text7, text8)
        }

        this.applyDragging()

        this.engPage1Container.visible = true;
        this.engPage2Container.visible = false;
        this.engPage3Container.visible = false;
        this.engPage4Container.visible = false;
        this.engPage5Container.visible = false;
        this.engPage6Container.visible = false;
        this.engPage7Container.visible = false;
        this.engPage8Container.visible = false;
        this.engPage9Container.visible = false;
        this.engPage10Container.visible = false;
        this.engPage11Container.visible = false;
        this.engPage12Container.visible = false;


        this.englishTutorialContainer.addChild(this.engPage1Container, this.engPage2Container, this.engPage3Container, this.engPage4Container, this.engPage5Container, this.engPage6Container, this.engPage7Container, this.engPage8Container, this.engPage9Container, this.engPage10Container, this.engPage11Container, this.engPage12Container)
    }

    applyDragging() {
        this.engPage11Container.interactive = fruitData.showAutoAndTurbo;
        this.engPage11Container.cursor = fruitData.showAutoAndTurbo ? 'grab' : 'default';

        let dragging = false;
        let startY = 0;
        let containerStartY = 0;

        const MIN_Y = -2740;  // how far up the container can go
        const MAX_Y = 0;     // how far down (usually 0 = starting pos)

        this.engPage11Container
            .on('pointerdown', (event) => {
                if (!fruitData.showAutoAndTurbo) return;
                dragging = true;
                startY = event.data.global.y;
                containerStartY = this.engPage11Container.y;
            })
            .on('pointermove', (event) => {
                if (!dragging || !fruitData.showAutoAndTurbo) return;

                const currentY = event.data.global.y;
                const delta = currentY - startY;

                let newY = containerStartY + delta;

                if (newY < MIN_Y) newY = MIN_Y;
                if (newY > MAX_Y) newY = MAX_Y;

                this.engPage11Container.y = newY;

                this.arrow.visible = true
                this.ftueEngScroll = false;
            })
            .on('pointerup', () => {
                dragging = false;
            })
            .on('pointerupoutside', () => {
                dragging = false;
            });
    }

    setupMask() {
        this.maskGraphic = new PIXI.Sprite(PIXI.Assets.get('gameScreen'));
        this.maskGraphic.anchor.set(0.5);
        this.maskGraphic.scale.set(1.125, 0.6);
        this.maskGraphic.alpha = 1
        this.maskGraphic.x = 0
        this.maskGraphic.y = -60

        this.ftueContainer.addChild(this.maskGraphic)
    }

    setupPopBoard() {
        this.ftueBoard = new PIXI.Sprite(PIXI.Assets.get("popup_board"));
        this.ftueBoard.anchor.set(0.5);

        const text = new PIXI.Text("Languages", {
            fontFamily: "Arial",
            fontSize: 55,
            fill: ["#ffffff", "#ffcc00"],
            fontWeight: "bold",
            stroke: "#000000",
            strokeThickness: 4,
            dropShadow: true,
            dropShadowColor: "#000000",
            dropShadowBlur: 6,
            dropShadowAngle: Math.PI / 6,
            dropShadowDistance: 4,
            align: "center"
        });

        text.anchor.set(0.5);
        text.y = -180

        this.engLang = new PIXI.Sprite(PIXI.Assets.get('lang_english'));
        this.engLang.anchor.set(0.5);
        this.engLang.scale.set(0.25)
        this.engLang.y = -50
        this.engLang.interactive = true;
        this.engLang.cursor = 'pointer';
        this.engLang.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                this.engLang.scale.set(0.18)
            }

        })

        this.engLang.on("pointerup", () => {
            this.engLang.scale.set(0.25)
            setLanguage('en')
            this.ftueBoard.visible = false;
            this.englishTutorialContainer.visible = true;
            this.ftueLanguage = 'eng';
            this.currentContainer = this.englishPages
            this.footerContainer.visible = true;
            this.skip_en.visible = true;

            instances.MenuPopUp.showTutorial('eng')
            instances.MenuPopUp.setActiveLanguage(
                'en'
            )
        })

        this.tagLang = new PIXI.Sprite(PIXI.Assets.get('lang_tagalog'));
        this.tagLang.anchor.set(0.5);
        this.tagLang.scale.set(0.25)
        this.tagLang.y = 120
        this.tagLang.interactive = true;
        this.tagLang.cursor = 'pointer';
        this.tagLang.on('pointerdown', (event) => {
            if (!event.data.originalEvent.button || event.data.originalEvent.pointerType === 'touch') {
                this.tagLang.scale.set(0.18)
            }
        })

        this.tagLang.on("pointerup", () => {
            this.tagLang.scale.set(0.25)
            setLanguage("tl")
            this.ftueBoard.visible = false;
            this.tagalogTutorialContainer.visible = true;
            this.ftueLanguage = 'tag';
            this.currentContainer = this.tagalogPages
            this.footerContainer.visible = true;
            this.skip_ph.visible = true;

            instances.MenuPopUp.showTutorial('tag')
            instances.MenuPopUp.setActiveLanguage(
                'tl'
            )
        })

        this.ftueBoard.addChild(text, this.engLang, this.tagLang)
        this.ftueContainer.addChild(this.ftueBoard);
    }
}